import request from '../request'

// 获取三会一课列表
export function getMeetingList(params) {
  return request({
    url: '/app/meeting/user/list',
    method: 'get',
    params,
  })
}

// 获取会议详情
export function getMeetingDetail(params) {
  return request({
    url: '/app/life/meeting/detail',
    method: 'get',
    params,
  })
}

// 获取会议纪要
export function getMeetingReport(params) {
  return request({
    url: '/app/meeting/report',
    method: 'get',
    params,
  })
}
